<div>
  <mat-accordion>
    <mat-expansion-panel [expanded]="activeLaneIndex === indexValue">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span>
            <span class="heading-lane">Lane {{ indexValue + 1 }}</span>&nbsp;&nbsp;
             @if(group.get('origin')?.value?.city){
            <span>{{ group.get('origin')?.value?.city }},&nbsp;{{ group.get('origin')?.value?.state }}</span>
            &nbsp;&nbsp;<up-icon name="arrow_forward"></up-icon>&nbsp;&nbsp;
            <span>{{ group.get('destination')?.value?.city }},&nbsp;{{ group.get('destination')?.value?.state }}</span>
             }
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="inline-row gap-top">
        <!-- Origin City State -->
        <div>
          <lib-location-external-autocomplete
            #cityStateDropdownOrigin
            [isSubmitted]="isSubmitted"
            searchField [location]="group.get('origin')?.value"
            [roleType]="'CITY_STATE'"
            [cityStateText]="true"
            [showErrors]="true"
            [placeHolder]="originCityStateLabel"
            [required]="true"
            (selectedLocation)="onSelected($event, 'origin')"
          >
          </lib-location-external-autocomplete>
        </div>
        <!-- Destination City State -->
        <div>
          <lib-location-external-autocomplete
            #cityStateDropdownDestination
            [isSubmitted]="isSubmitted"
            searchField [location]="group.get('destination')?.value"
            [roleType]="'CITY_STATE'"
            [cityStateText]="true"
            [showErrors]="true"
            [placeHolder]="destinationCityStateLabel"
            [required]="true"
            (selectedLocation)="onSelected($event, 'destination')"
          >
          </lib-location-external-autocomplete>
        </div>
      </div>
      <br />
      <!-- services Check boxes -->
      <div>
        <app-transport-type
          #transloadType
          [label]="'Is transloading required?'"
          [group]="group.get('transloadingServicesRequired')"
          (noAction)="transloadNo($event)"
          (fromObject)="updateFormDate($event, 'transloadingServicesRequired')"
          [isSubmitted]="isSubmitted"
          [isRailSelected]="isRailSelected"
        >
        </app-transport-type>
        <app-transport-type
          #truckType
          [label]="'Do you need trucking services?'"
          [group]="group.get('truckingServicesRequired')"
          (fromObject)="updateFormDate($event, 'truckingServicesRequired')"
          [isSubmitted]="isSubmitted"
          [isRailSelected]="isRailSelected"
        >
        </app-transport-type>
        @if(!showStorage){
        <app-transport-type
          #storageType
          [label]="'Is storage needed?'"
          [group]="group.get('storageServicesRequired')"
          (fromObject)="updateFormDate($event, 'storageServicesRequired')"
          [isSubmitted]="isSubmitted"
          [isRailSelected]="isRailSelected"
        >
        </app-transport-type>
        }
      </div>
      <!-- Potential Units -->
      <div>Estimated shipment volume</div>
      <div class="inline-row">
        <div>
          <lib-text-field-alls
            #potentialUnit
            [isSubmitted]="isSubmitted"
            [errorMessage]="'Potential Units is required.'"
            [fullWidth]="true"
            [showInUpperCase]="false"
            [alignmentRight]="false"
            [fieldLabel]="potentialUnitLabel"
            [placeholder]="'00000'"
            [onlyNumeric]="true"
            [fieldLength]="5"
            [fieldName]="'potentialUnits'"
            [showError]="true"
            [required]="true"
            [formControlData]="group"
            (inputFieldData)="fieldValue($event, 'potentialUnits')"
          ></lib-text-field-alls>
        </div>
        <!-- VOLUME_DURATION -->
        <div>
          <lib-external-dropdown
            #volumeDropdown
            [propertyType]="'VOLUME_UOM'"
            [isSubmitted]="isSubmitted"
            [formControlData]="group"
            [dropDownName]="'volumeDuration'"
            [labelName]="volumeDurationLabel"
            [fullWidth]="true"
            [showErrors]="true"
            [required]="true"
            (selectedType)="onSelected($event, 'unitOfMeasure')"
          >
          </lib-external-dropdown>
        </div>
        <!-- VOLUME_DURATION_UOM -->
        <div>
          <lib-external-dropdown
            #volumeUomDropdown
            [propertyType]="'VOLUME_DURATION_UOM'"
            [isSubmitted]="isSubmitted"
            [formControlData]="group"
            [dropDownName]="'volumeDurationUom'"
            [labelName]="volumeDurationUomLabel"
            [fullWidth]="true"
            [showErrors]="true"
            [required]="true"
            (selectedType)="onSelected($event, 'timeFrame')"
          >
          </lib-external-dropdown>
        </div>
      </div>
      <br />
      <!-- Action Buttons -->
      <div>
        <up-button button-style="outlined" (click)="copyLaneAction(indexValue)"
          >copy</up-button
        >&nbsp;&nbsp; @if(indexValue > 0){
        <up-button
          button-style="outlined"
          (click)="delateLaneAction(indexValue)"
          >delete</up-button
        >
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
